import { render, staticRenderFns } from "./PortfolioWriteComponent.vue?vue&type=template&id=2dae9a68&scoped=true&"
import script from "./PortfolioWriteComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dae9a68",
  null
  
)

export default component.exports